var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"card":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Contacts"}},[_c('contacts-table')],1),_c('b-tab',{attrs:{"title":"+"}},[_c('contact-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }